import { NgModule } from '@angular/core';
import { DatePickerComponent } from './date-picker-component';
import { IonicModule } from 'ionic-angular';
var DatePickerModule = (function () {
    function DatePickerModule() {
    }
    DatePickerModule.forRoot = function () {
        return {
            ngModule: DatePickerModule,
        };
    };
    DatePickerModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        IonicModule
                    ],
                    declarations: [
                        DatePickerComponent
                    ],
                    exports: [
                        DatePickerComponent,
                    ]
                },] },
    ];
    /** @nocollapse */
    DatePickerModule.ctorParameters = function () { return []; };
    return DatePickerModule;
}());
export { DatePickerModule };
//# sourceMappingURL=date-picker.module.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ionic-calendar-date-picker/dist/components/date-picker.module.js
// module id = 960
// module chunks = 1